import { render, staticRenderFns } from "./MaterialChartCard.vue?vue&type=template&id=bffe8a38&lang=pug&"
import script from "./MaterialChartCard.vue?vue&type=script&lang=ts&"
export * from "./MaterialChartCard.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialChartCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
